module.exports = __webpack_public_path__ + "static/b6-9aec15a22d565aabd662bbe10dc5a5b1.jpg";